import Loadable from "components/Loadable";
import {lazy} from "react";
import ProfileBase from "pages/profile/ProfileBase";
const ChangePassword = Loadable(lazy(() => import('pages/profile/change-password/change-password')));
const ProfileDetails = Loadable(lazy(() => import('pages/profile/details/profile-details')));
const MyAttendance = Loadable(lazy(() => import('pages/attendance/user/my-attendance/my-attendance')));
const UserLeaveApplications = Loadable(lazy(() => import('pages/attendance/user/leave-applications/user-leave-application')));
const MyTaskList = Loadable(lazy(() => import('pages/profile/my-tasks/my-task-list')));
const ViewMyTask = Loadable(lazy(() => import('pages/profile/my-tasks/view-my-task')));
const MyFollowUpList = Loadable(lazy(() => import('pages/profile/my-follow-ups/my-follow-up-list')));
const ViewMyFollowUp = Loadable(lazy(() => import('pages/profile/my-follow-ups/view-my-follow-ups')));
const MyExpensesList = Loadable(lazy(() => import('pages/profile/my-expenses/my-expenses-list')));
const ViewMyExpense = Loadable(lazy(() => import('pages/profile/my-expenses/view-my-expenses')));
const Profile = {
    path: 'profile',
    element: <ProfileBase />,
    children: [
        {
            path: '',
            element: <ProfileDetails />
        },

        {
            path: 'change-password',
            element: <ChangePassword />
        },
        {
            path: 'my-attendance',
            element: <MyAttendance />
        },
        {
            path: 'my-leave-applications',
            element: <UserLeaveApplications />
        },
        {
            path: 'my-follow-ups',
            element: <MyFollowUpList />
        },
        {
            path: 'my-follow-ups/:follow_up_id',
            element: <ViewMyFollowUp />
        },
        {
            path: 'my-expenses',
            element: <MyExpensesList />
        },
        {
            path: 'my-expenses/:expense_id',
            element: <ViewMyExpense />
        },
        {
            path: 'my-tasks',
            element: <MyTaskList />
        },
        {
            path: 'my-tasks/:task_id',
            element: <ViewMyTask />
        }
    ]}
export default Profile;
